import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="d-flex justify-content-center p-5">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Block integration-only users from accessing frontend
  if (user.role === 'LocalAPI') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;


